import React from "react";
import { motion } from "framer-motion";

const letters = {
  G: {
    width: 80,
    height: 100,
    viewBox: "0 0 8 10",
    d: "M7.88121 9.05582L7.93203 9.02712V8.96875V5.16016V5.06016H7.83203H5.00781H4.90781V5.16016V6.05078V6.15078H5.00781H6.74766V8.34613C6.29546 8.58008 5.76147 8.69883 5.14258 8.69883C4.20861 8.69883 3.47934 8.40445 2.9428 7.82299C2.40555 7.23686 2.13125 6.42763 2.13125 5.38281C2.13125 4.37232 2.42531 3.5582 3.0069 2.93129C3.58822 2.30468 4.33245 1.99063 5.24805 1.99063C6.16183 1.99063 6.94735 2.2016 7.60867 2.61968L7.76211 2.71668V2.53516V1.44531V1.38227L7.70524 1.35509C7.06702 1.05003 6.28369 0.9 5.35938 0.9C4.07311 0.9 3.00377 1.32718 2.15926 2.1837L2.15926 2.1837C1.31833 3.03664 0.9 4.12932 0.9 5.45312C0.9 6.74705 1.27574 7.79698 2.03509 8.59249L2.03527 8.59268C2.79864 9.38819 3.79663 9.78359 5.01953 9.78359C6.06687 9.78359 7.02149 9.5414 7.88121 9.05582Z",
  },
  O: {
    width: 60,
    height: 60,
    viewBox: "0 0 6 8",
    d: "M1.28056 6.37113L1.28105 6.37165C1.83407 6.95313 2.57086 7.24062 3.48047 7.24062C4.41354 7.24062 5.16625 6.94528 5.7272 6.34774C6.29105 5.74738 6.56875 4.95346 6.56875 3.97656C6.56875 2.983 6.31215 2.19249 5.7868 1.61819C5.26405 1.04243 4.53754 0.759375 3.62109 0.759375C2.66202 0.759375 1.89007 1.04992 1.31698 1.63927C0.743416 2.2291 0.4625 3.04396 0.4625 4.07031C0.4625 5.0161 0.732469 5.7865 1.28056 6.37113ZM2.16176 2.36598L2.16206 2.36563C2.50014 1.96876 2.95915 1.76797 3.55078 1.76797C4.14799 1.76797 4.59357 1.96198 4.90304 2.34063L4.9034 2.34107C5.21935 2.72314 5.38438 3.27533 5.38438 4.01172C5.38438 4.74008 5.21945 5.28626 4.90371 5.66442L4.90334 5.66487C4.59398 6.03973 4.14833 6.23203 3.55078 6.23203C2.96644 6.23203 2.5087 6.03667 2.16666 5.65049C1.82391 5.26352 1.64688 4.72911 1.64688 4.03516C1.64688 3.31261 1.8226 2.76043 2.16176 2.36598Z",
  },
  U: {
    width: 60,
    height: 60,
    viewBox: "0 0 7 8",
    d: "M5.82422 7.1H5.92422V7V1V0.9H5.82422H4.86328H4.76328V1V4.45703C4.76328 4.99667 4.61658 5.4247 4.33104 5.7505L4.33099 5.75056C4.04976 6.07196 3.69273 6.23203 3.25195 6.23203C2.79122 6.23203 2.46065 6.08293 2.24152 5.79664C2.01851 5.50529 1.89883 5.05647 1.89883 4.43359V1V0.9H1.79883H0.84375H0.74375V1V4.58594C0.74375 5.44906 0.924522 6.11504 1.30329 6.56625C1.68488 7.02081 2.25298 7.24062 2.98828 7.24062C3.42107 7.24062 3.80248 7.14645 4.12885 6.95434C4.37448 6.80977 4.58575 6.61159 4.76328 6.3619V7V7.1H4.86328H5.82422Z",
  },
  R: {
    width: 37.5,
    height: 60,
    viewBox: "0.5 0 5 8",
    d: "M4.04068 2.05199L4.20156 2.17545V1.97266V0.976562V0.909593L4.13964 0.884095C3.98894 0.822044 3.78217 0.794531 3.52734 0.794531C3.15464 0.794531 2.81771 0.92298 2.51966 1.17539C2.32314 1.33923 2.16144 1.54501 2.03359 1.79092V1V0.9H1.93359H0.972656H0.872656V1V7V7.1H0.972656H1.93359H2.03359V7V3.94141C2.03359 3.28607 2.16783 2.78154 2.42521 2.41738C2.68718 2.05223 3.00266 1.8793 3.375 1.8793C3.67978 1.8793 3.89693 1.94167 4.04068 2.05199Z",
  },
  M: {
    width: 75,
    height: 60,
    viewBox: "0.5 0 10 8",
    d: "M9.49219 7.1H9.59219V7V3.30273C9.59219 2.47737 9.42536 1.83979 9.07476 1.40725C8.7209 0.970685 8.1935 0.759375 7.51172 0.759375C7.05407 0.759375 6.64852 0.866911 6.29865 1.08507C6.00225 1.26988 5.74981 1.53158 5.54012 1.86682C5.4122 1.56898 5.21615 1.32115 4.95257 1.12507C4.62928 0.880643 4.25039 0.759375 3.82031 0.759375C3.06615 0.759375 2.46821 1.05881 2.03359 1.65037V1V0.9H1.93359H0.972656H0.872656V1V7V7.1H0.972656H1.93359H2.03359V7V3.57812C2.03359 3.02783 2.16624 2.59229 2.42269 2.26257L2.42301 2.26214C2.6789 1.92948 2.99809 1.76797 3.38672 1.76797C3.81844 1.76797 4.12709 1.90653 4.33147 2.17144C4.53965 2.44126 4.65195 2.85773 4.65195 3.4375V7V7.1H4.75195H5.71289H5.81289V7V3.57812C5.81289 3.07412 5.9497 2.64688 6.22002 2.29127C6.49342 1.93671 6.81544 1.76797 7.18945 1.76797C7.65339 1.76797 7.95981 1.90907 8.13817 2.16975L8.13817 2.16975L8.13868 2.17048C8.32772 2.44157 8.43125 2.89631 8.43125 3.55469V7V7.1H8.53125H9.49219Z",
  },
  E: {
    width: 50,
    height: 60,
    viewBox: "0 0 6 8",
    d: "M5.79492 4.34023H5.89492V4.24023V3.73633C5.89492 2.81878 5.67639 2.08791 5.22673 1.5565C4.77455 1.02211 4.13683 0.759375 3.32812 0.759375C2.51428 0.759375 1.82919 1.06658 1.27921 1.67722L1.27919 1.67724C0.732355 2.28483 0.4625 3.06996 0.4625 4.02344C0.4625 5.02745 0.708666 5.82171 1.2142 6.39248L1.21444 6.39274C1.72098 6.96056 2.41613 7.24062 3.28711 7.24062C4.16849 7.24062 4.88838 7.04606 5.43765 6.64733L5.47891 6.61738V6.56641V5.66406V5.45824L5.3171 5.58545C4.76707 6.01789 4.16745 6.23203 3.51562 6.23203C2.93553 6.23203 2.49139 6.05772 2.17029 5.71838C1.86566 5.39644 1.69277 4.94101 1.66234 4.34023H5.79492ZM4.32998 2.19554L4.32998 2.19554L4.33046 2.1961C4.56031 2.46312 4.68974 2.8361 4.70831 3.32578H1.68777C1.77034 2.87284 1.95146 2.50732 2.22782 2.22414C2.5254 1.91921 2.88436 1.76797 3.31055 1.76797C3.7551 1.76797 4.09038 1.91302 4.32998 2.19554Z",
  },
  T: {
    width: 40,
    height: 80,
    viewBox: "0 0 5 9.5",
    d: "M3.86705 2.45453V2.35453H3.76705H2.46932V0.886353V0.786353H2.36932H1.36364H1.26364V0.886353V2.35453H0.375H0.275V2.45453V3.30681V3.40681H0.375H1.26364V7.39772C1.26364 7.79392 1.35545 8.13074 1.54609 8.40134L1.54653 8.40195C1.73534 8.66568 1.97338 8.86339 2.2599 8.99308L2.26026 8.99324C2.54516 9.12085 2.83746 9.18522 3.13636 9.18522C3.32759 9.18522 3.49032 9.17084 3.62239 9.14026C3.74607 9.11434 3.84656 9.08762 3.92148 9.05953L4.00316 9.0289L3.9839 8.94382L3.77935 8.04041L3.75782 7.94531L3.66221 7.96443L3.4937 7.99813C3.43011 8.00815 3.34559 8.01363 3.23864 8.01363C3.10182 8.01363 2.97254 7.99268 2.85025 7.95121C2.74491 7.91196 2.65401 7.83543 2.57881 7.71301C2.50993 7.59356 2.46932 7.4019 2.46932 7.12499V3.40681H3.76705H3.86705V3.30681V2.45453Z",
  },
};

const icon = {
  hidden: {
    opacity: 0,
    pathLength: 0,
    fill: "rgb(255, 48, 0, 0)",
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    fill: "rgb(255, 48, 0, 1)",
  },
};

const AnimatedTitle = () => {
  return (
    <div>
      {Object.keys(letters).map((index) => {
        return (
          <motion.svg
            width={letters[index].width}
            height={letters[index].height}
            viewBox={letters[index].viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            index={index}
            className="motion-svg"
          >
            <motion.path
              d={letters[index].d}
              stroke="#f50000"
              stroke-width="0.2"
              variants={icon}
              initial="hidden"
              animate="visible"
              transition={{
                default: { duration: 3, ease: "easeInOut" },
                fill: { duration: 4, ease: [1, 0, 0.8, 1] },
              }}
            />
          </motion.svg>
        );
      })}
    </div>
  );
};

export default AnimatedTitle;
